import { z } from 'zod';
import { defineEndpoint } from '../define';
import { AppleUdidInputSchema, UdidLabelSchema, UserAppleUdidSchema } from './shapes';

export const CreateAppleUdidBodySchema = z
  .object({
    udid: AppleUdidInputSchema,
    label: UdidLabelSchema,
  })
  .strict();
export type CreateAppleUdidBody = z.infer<typeof CreateAppleUdidBodySchema>;

export const createAppleUdid = defineEndpoint({
  method: 'POST',
  path: '/v1/apple-udids',
  params: z.object({}),
  query: z.object({}),
  body: CreateAppleUdidBodySchema,
  response: z.object({ data: UserAppleUdidSchema }),
  successStatus: 201,
});
